import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';
import { Badge } from 'lib/components/Badge';
import { ColumnButton } from 'lib/components/ColumnButton';
import { Modal } from 'lib/components/Modal';
import { Link } from 'react-router-dom';

type NetworkInfoModalProps = {
  onClose: () => void;
};

export default function NetworkInfoModal({ onClose }: NetworkInfoModalProps) {
  return (
    <Modal
      id="extended-network-info"
      onClose={onClose}
      title="Column Partner vs. Extended Network"
    >
      <div className="space-y-3">
        <div className="space-y-2">
          <Badge size="lg" status="info">
            Column Partner
          </Badge>
          <p>
            This publisher is a Column partner which means you can expect fast
            turnaround times, accurate pricing &amp; proofs, timely payment,
            verified affidavits, and more.
          </p>
        </div>
        <div className="space-y-2">
          <Badge size="lg" status="warning">
            Extended Network
          </Badge>
          <p>
            This publisher is an adjudicated publication, but not a Column
            partner. We can fulfill your notice order via our Extended Network
            service for a small handling fee.
          </p>
        </div>

        <div>
          <Link target="_blank" to="https://help.column.us/en/articles/3464832">
            <ColumnButton
              type="button"
              buttonText="Learn more"
              primary
              size="lg"
              endIcon={<ArrowTopRightOnSquareIcon className="h-4 w-4" />}
            />
          </Link>
        </div>
      </div>
    </Modal>
  );
}
